import { CropYear } from "../cropYear"
import { IDocumentLibraryService } from "../documents"
import { IOmniaSession } from "../types"
import { IDocumentLibraryArguments, ImportDocumentVm } from "./types"
import { filterDocuments, getSizeInfo } from "./utils"

export interface DoclibState {

    readonly svc: IDocumentLibraryService
    readonly session: IOmniaSession

    readonly size: ReturnType<typeof getSizeInfo>

    readonly documents: ImportDocumentVm[]
    readonly visibleDocs: ImportDocumentVm[]

    readonly documentSelection: boolean
    readonly multipleSelection: boolean
    readonly manageLibrary: boolean
    readonly limitToPictures: boolean

    readonly years: CropYear[]
    readonly year: number

    readonly search: string

}

export function createEmptyState(svc: IDocumentLibraryService, session: IOmniaSession, args?: IDocumentLibraryArguments): DoclibState {

    args = args || {
        selection: true,
        multipleSelection: true,
        manageLibrary: false,
        limitToPictures: false
    }

    return {
        svc,
        session,
        size: getSizeInfo(session),
        documents: [],
        visibleDocs: [],
        documentSelection: args.selection,
        multipleSelection: args.multipleSelection,
        manageLibrary: args.manageLibrary,
        limitToPictures: args.limitToPictures,
        years: session.getCroppingYears(),
        year: session.yearId,
        search: undefined
    }

}

export function createInitialState(state: DoclibState): PromiseLike<DoclibState> {


    return state.svc.readFiles(state.year).then(docs => {

        const documents = docs.map(d => ({ document: d, selected: false }))

        state = { ...state, documents }
        state = { ...state, visibleDocs: filterDocuments(state) }

        return state

    })
}

export function selectYear(state: DoclibState, year: number) {

    state = {
        ...state,
        year
    }

    return createInitialState(state)

}

export function selectSize(state: DoclibState, sizeId: string) {

    const { size } = state

    return {
        ...state,
        size: size.setCurrent(sizeId)
    }

}

export function selectDocument(s: DoclibState, doc: ImportDocumentVm, select: boolean) {

    const newDoc = { ...doc, selected: select }

    const replace = (a: ImportDocumentVm[]) => a.map(
        d => d.document.ImportDocumentId === doc.document.ImportDocumentId ?
            newDoc :
            d)

    return {
        ...s,
        documents: replace(s.documents),
        visibleDocs: replace(s.visibleDocs)
    }
}

export function applyFilter(state: DoclibState, search: string) {

    state = { ...state, search }

    return {
        ...state,
        visibleDocs: filterDocuments(state)
    }

}
